import type { IContact } from "@bbj-types/contact";
import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axiosEnterprise } from "./axios";

export const useGetContact = () => {
  const [state, execute, cancel] = axiosEnterprise<IContact, void, unknown>(
    {
      method: "get",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (contactId: ObjectId) => {
      return execute({
        url: `/v2/contacts/${contactId}`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
